import {
  CheckCircleIcon,
  InfoIcon,
  WarningCircleIcon,
  WarningIcon,
} from "@phosphor-icons/react";
import type { ReactNode } from "react";

import { cn } from "../../lib/cn";

type StatusTone = "info" | "success" | "warning" | "danger";

type StatusBannerProps = {
  title: string;
  description?: string;
  tone?: StatusTone;
  action?: ReactNode;
  className?: string;
};

const styles: Record<StatusTone, string> = {
  info: "border-info-border bg-info-soft text-info-strong",
  success: "border-success-border bg-success-soft text-success-strong",
  warning: "border-warning-border bg-warning-soft text-warning-strong",
  danger: "border-danger-border bg-danger-soft text-danger-strong",
};

const icons = {
  info: InfoIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
  danger: WarningCircleIcon,
};

export function StatusBanner({
  action,
  className,
  description,
  title,
  tone = "info",
}: StatusBannerProps) {
  const Icon = icons[tone];
  const role = tone === "danger" ? "alert" : "status";

  return (
    <section className={cn("flex items-start gap-3 rounded-panel border p-4", styles[tone], className)} role={role}>
      <Icon aria-hidden="true" className="mt-0.5 size-5 shrink-0" weight="fill" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{title}</p>
        {description ? <p className="mt-1 text-sm text-current/85">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </section>
  );
}
